import 'bootstrap';
import './css/bootstrap.less';

import './css/layout.scss';

export function base() {
  $(function () {
    initialize();
  });
}

function initialize() {
  // Bootstrap ToolTips
  $('[data-toggle="tooltip"]').tooltip();
}
